export default "__VITE_ASSET__Ca4LBKjKib5nRGc7lsyQwg__"